import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useFadeIn } from "@/hooks/useFadeIn";
import drImage from "@/assets/about-caribbean.jpg";

const DRInvestSection = () => {
  const { ref, visible } = useFadeIn();

  return (
    <section className="py-24 md:py-32 bg-[#123d2f] overflow-hidden">
      <div
        ref={ref}
        className={`mx-auto max-w-wide px-5 md:px-12 transition-all duration-700 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="grid grid-cols-1 lg:grid-cols-[0.95fr_1.05fr] gap-12 lg:gap-16 items-center">
          <div className="max-w-xl lg:max-w-lg">
            <span className="font-body text-[10px] uppercase tracking-[0.3em] text-accent mb-4 block">
              Global Opportunity
            </span>
            <h2 className="font-headline text-3xl md:text-[3.05rem] lg:text-[3.65rem] text-secondary-foreground mb-4 leading-[1.06]">
              Invest Beyond Massachusetts
            </h2>
            <p className="font-body text-xs uppercase tracking-[0.17em] text-accent/90 mb-4">
              Growing demand. Limited supply. Strong rental upside.
            </p>
            <p className="max-w-[31rem] text-secondary-foreground/85 text-base md:text-lg leading-[1.7] mb-8">
              Explore Dominican Republic real estate with strategy for second homes, vacation rentals, and long-term investment growth.
            </p>
            <Button variant="gold" size="lg" className="gap-2.5" asChild>
              <Link to="/dominican-republic">
                Explore Investment Opportunities
                <ArrowRight className="w-4 h-4" />
              </Link>
            </Button>
          </div>
          <div className="w-full">
            <div className="relative aspect-[5/4] overflow-hidden border border-white/10">
              <img
                src={drImage}
                alt="Dominican Republic real estate investment property"
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
                width={1400}
                height={1120}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-black/10 to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DRInvestSection;
